import axios from "axios";
import { endpoints } from "../_config";

class TrackService {
  /**
   * Get all Tracks
   * @param {*} Bearer token
   * @returns
   */
  static async getAllTracks(user, params) {
    return axios
      .get(endpoints.track.getAll, {
        headers: {
          Authorization: "Bearer " + user.token,
        },
        params,
      })
      .then((response) => response.data);
  }

  /**
   * Delete Track
   * @param {*}
   * @returns
   */
  static async deleteTrack(user, trackId) {
    return axios
      .delete(endpoints.track.deleteTrack(trackId), {
        headers: {
          Authorization: "Bearer " + user.token,
        },
      })
      .then((response) => response.data);
  }

  /**
   * Upload audio Service
   * @param {*} image file
   * @returns
   */
  static async uploadAudio(user, file) {
    return axios
      .post(endpoints.imageUpload.fileUpload, file, {
        headers: {
          Authorization: "Bearer " + user.token,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => response.data);
  }

  /**
   * Add Track Api
   * @param {*}
   * @returns
   */
  static async addTrack(user, data) {
    return axios
      .post(endpoints.track.addTrack, data, {
        headers: {
          Authorization: "Bearer " + user.token,
        },
      })
      .then((response) => response.data);
  }

  /**
   * Update Track Api
   * @param user, data(track object)
   * @returns
   */
  static async updateTrack(user, trackId, data) {
    return axios
      .put(endpoints.track.editTrack(trackId), data, {
        headers: {
          Authorization: "Bearer " + user.token,
        },
      })
      .then((response) => response.data);
  }
}

export { TrackService };
